export enum Priority {
    None = 0,
    One = 1,
    Two = 2,
    Three = 3
}
